import React from "react"
import styled from "styled-components"
import Resources from "../../resources/mlp-resources.json"
import { useSiteContent } from "../hooks/use-site-content"

const CustomMapWrapper = styled.div`
  width: ${Resources.contact_form.map.width};
  height: ${Resources.contact_form.map.height};

  iframe {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    iframe {
      border-radius: 0;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    iframe {
      border-radius: 0;
    }
  }
`

const CustomMap = () => {
  const {
    contact: { lat, lng },
  } = useSiteContent()

  const query = `${lat},${lng}`
  const src =
    "https://www.google.com/maps?q=" +
    encodeURIComponent(query) +
    `&z=${Resources.contact_form.map.zoom}&output=embed`

  return (
    <CustomMapWrapper>
      <iframe
        title="Ubicación MLP"
        src={src}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </CustomMapWrapper>
  )
}

export default CustomMap
